export function toURL(url: Maybe<string>): string {
  if (!url) return '';
  return /^https?:\/\//.test(url.trim()) ? url : `https://${url}`;
}

export function toLabelURL(url: Maybe<string>): string {
  if (!url) return '';
  return url.replace(/(^https?:\/\/(www\.)?|\?.+$)/g, '');
}
